import { Base2Presenter } from "core/presenter";
import { ProductRepository } from "core/repository";

class InfoKitPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: true,
      allProducts: [],
      items: []
    };
  }

  async onStart() {
    await this.getAllProducts();
    this.createItem();
  }

  createItem() {
    const { products_uuids } = this.props.product;
    const items = [];

    if (!!products_uuids) {
      Object.entries(products_uuids).forEach(([field, content]) =>
        items.push({
          uuid: field,
          quantity: content,
          name: this.getProductName(field)
        })
      );

      this.enqueue({ items });
    }
  }

  getProductName(uuid) {
    const product = this.viewModel.allProducts.find(
      product => product.uuid === uuid
    ) || { name: "" };
    return product.name;
  }

  async getAllProducts() {
    const { products_uuids } = this.props.product;

    const products = Object.keys(products_uuids).map(async uuid => {
      const repositoryResult = await ProductRepository.get(uuid);
      return repositoryResult.success ? repositoryResult.data : null;
    });

    const allProducts = await Promise.all(products);

    if (allProducts.includes(null)) {
      this.sendNotification({
        type: "error",
        title: "Oooops...",
        content:
          "Não conseguimos carregar os produtos do kit! Tente novamente em alguns minutos ou entre em contato com o suporte."
      });
    } else {
      this.enqueue({ allProducts });
    }

    this.enqueue({ loading: false });
  }

  getFilter(value) {
    return [
      { field: "name", operation: "LIKE", value },
      { field: "deleted", operation: "EQ", value: false }
    ];
  }
}

export default InfoKitPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/info/kit-info/presenter.js